<template>
    <span>
       {{time}}
    </span>
</template>

<script>
  import {PPComponentMixin, PPPlayerMethodsMixin} from "../mixins";
  import {durationToString} from "../utils";

  export default {
    name: "PPLabelTimeLeft",
    mixins: [PPComponentMixin, PPPlayerMethodsMixin],
    props: {
      periodTime: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      time() {
        const player = this.player.ad.active ? this.player.ad : this.player;

        if (!player || player.duration === Number.NaN
           || player.duration === Infinity) {
          return "";
        }
        let format = '%hh:%mm:%ss';
        let duration = player.duration;
        let currentTime = player.currentTime;

        if (this.periodTime) {
          duration = player.periodDuration;
          currentTime = player.periodTime;
        }

        if (player.duration <= 3600) {
          format = '%mm:%ss';
        }

        return '-' + durationToString(duration - currentTime, format);
      }
    }
  }
</script>
